import { makeStyles } from '@mui/styles';
import React from 'react';

import { useTranslation } from '../../../custom-hooks/useTranslation';

const useStyles = makeStyles({
  root: {
    padding: '8px 32px 8px 8px',
    fontWeight: 400,
  },
});

const ChangedRules = ({ rulesChanges }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  return (
    <div className={classes.root}>
      <div>{translateString('Changed Rules:')}</div>
      {rulesChanges.map(({ name }) => (
        <div key={name}>{`- ${name}`}</div>
      ))}
    </div>
  );
};

export default ChangedRules;
